import { render } from "./CIS-Home-Update.vue?vue&type=template&id=8be73f1a&scoped=true"
import script from "./CIS-Home-Update.vue?vue&type=script&lang=js"
export * from "./CIS-Home-Update.vue?vue&type=script&lang=js"

import "./CIS-Home-Update.vue?vue&type=style&index=0&id=8be73f1a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8be73f1a"]])

export default __exports__